<template>
  <section v-show="title!==''">
    <div class="hero md:px-48 px-10 flex items-end ">
      <h1 class="text-7xl text-white text-shadow-pop-left">{{$t(title)}}</h1>
    </div>
    <divider-section :item-class="itemClass"></divider-section>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import DividerSection from '@/components/hero/DividerSection.vue';

export default {
  name: 'HeroSection',
  data() {
    return {
      itemClass: 'h-20',
    };
  },
  components: {
    DividerSection,
  },
  computed: {
    ...mapGetters(['title']),
  },
};
</script>
<style scoped>
  .hero {
    background: rgb(51,51,51);
    background: linear-gradient(90deg, rgba(51,51,51,1) 15%, rgba(94,15,11,1) 100%);
    height: 200px;
  }
</style>
